export type UrlQuery = {
	name: string;
	value: string;
};

/**
 * Appends the user token and url queries to a url.
 */
export const makeApiUrl = (url: string, token?: string, query?: UrlQuery[]) => {
	if (token) {
		const tokenQuery: UrlQuery = {
			name: "token",
			value: token
		};
		query = (query ? query : []).concat([tokenQuery]);
	}

	if (!url.endsWith("/")) {
		url += "/";
	}

	if (query && query.length > 0) {
		url += "?" + query.map(q => `${q.name}=${q.value}`).join("&");
	}

	return url;
};
